import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import { Button } from "antd";
import { TableContainer } from "components/TableContainer";
import AuthorisedContainer from 'components/AuthorisedContainer'
import { PermissionSetMap } from 'constants/RBACConstants';
import { CustomToolAPI } from 'restAPI/ToolsIntegrationAPI'
import CustomToolForm, { ToolMapField, CUSTOM_PREFIX } from './CustomToolForm';
import ModalUtil from 'utils/modalUtil'


export default function CustomToolMapSettings({ toolId }) {
    const [toolMapData, setToolMapData] = useState([])
    const [activeItem, setActiveItem] = useState({})

    const convertToTableData = (toolMapInfo) => {
        const toolMapInfoArr = [];
        Object.keys(toolMapInfo.fieldMapping).forEach(key => {
            toolMapInfoArr.push({ fieldName: ToolMapField[key], customFieldName: toolMapInfo.fieldMapping[key].customFieldName, dedupField: toolMapInfo.fieldMapping[key].isDedupField })
        })
        return toolMapInfoArr;
    }
    const fetchData = useCallback(async () => {
        const res = await CustomToolAPI.getCustomTool(toolId).promise
        setActiveItem(res)
        setToolMapData(convertToTableData(res))
    }, [toolId])

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const tableColumns = [{
        title: "Field (ArmorCode Label)",
        dataIndex: "fieldName",
        disabled : !_.isUndefined(toolId),
        render: value => _.isObject(value)? value : _.replace(value, '_', ' ')
    },
    {
        title: "Mapped to",
        dataIndex: "customFieldName",
        render: value => value || '-'
    },
    {
        title: "Use for deduplication",
        dataIndex: "dedupField",
        render: value => value ? 'Yes' : 'No'
    }
    ]
    const modifyProps = (toolObj) => {
        const { name, toolType, dateFormat, fieldMapping } = toolObj;
        const fieldCheck = {}
        const propsObj = {
            name: name.split(CUSTOM_PREFIX)[1],
            category: toolType,
            dateFormat
        };
        Object.keys(fieldMapping).forEach(key => {
            propsObj[key] = fieldMapping[key].customFieldName;
            fieldCheck[key] = fieldMapping[key].isDedupField;
            if(fieldMapping[key].otherProperties){
                Object.assign(propsObj,fieldMapping[key].otherProperties)
            }
        })
        return { propsObj, fieldCheck };
    }

    const customEditForm = useCallback(() => {
        const { id: editId } = activeItem;
        const { propsObj, fieldCheck } = modifyProps(activeItem);
        ModalUtil.show({
            content: <CustomToolForm editId={editId} toolData={propsObj} fieldCheck={fieldCheck} />,
            afterClose: ()=> {
                setActiveItem();
                fetchData();
            }
        })
    }, [activeItem, fetchData])

    return (
        <TableContainer
            loading={_.isEmpty(activeItem)}
            style={{ overflowY: 'hidden' }}
            columns={tableColumns}
            dataSource={toolMapData}
            locale={{ emptyText: "No configurations" }}
            extras={<div className="text-right m-b-sm m-r-sm">
                <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS} >
                    <Button
                        size="small" type="primary"
                        onClick={customEditForm}
                    >
                        Edit
                    </Button>
                </AuthorisedContainer>
            </div>}
        />
    )
}
